// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Scalar from "../../core/Scalar.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogDuplicationForm from "../../modules/Catalog/CatalogDuplicationForm.res.js";
import * as CatalogDuplicationPage from "./CatalogDuplicationPage.res.js";
import * as CatalogDuplication__Config from "./CatalogDuplication__Config.res.js";
import * as CatalogDuplication__Queries from "./CatalogDuplication__Queries.res.js";

let schema = [
  {
    TAG: "Custom",
    _0: "Source",
    _1: param => {
      if (Stdlib_Option.isSome(param.source)) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Please select a catalog to duplicate.")
        };
      }
    }
  },
  {
    TAG: "Custom",
    _0: "Destinations",
    _1: param => {
      if (param.destinations.length !== 0) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("Please select at least one target shop to duplicate to.")
        };
      }
    }
  }
];

function CatalogDuplicationContainer(props) {
  let duplicationMode = props.mode;
  let cku = props.cku;
  let match = CatalogDuplication__Queries.ProductsQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executeProductsQuery = match[0];
  let match$1 = CatalogDuplication__Queries.VariantsQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let executeVariantsQuery = match$1[0];
  let match$2 = Navigation.useGoBack();
  let onGoBack = match$2[1];
  let notifier = Notifier.use("KeepOnHistoryChanges", undefined);
  let dispatch = Auth.useDispatch();
  React.useEffect(() => {
    notifier.clear();
    if (duplicationMode === "Product") {
      executeProductsQuery(undefined, undefined, CatalogDuplication__Queries.ProductsQuery.makeVariables(Scalar.CKU.serialize(cku), undefined));
    } else {
      executeVariantsQuery(undefined, undefined, CatalogDuplication__Queries.VariantsQuery.makeVariables(Scalar.CKU.serialize(cku), undefined));
    }
  }, []);
  let onSubmitSuccess = React.useCallback(message => {
    dispatch({
      TAG: "ActiveShopSet",
      _0: undefined
    });
    notifier.reset({
      TAG: "Success",
      _0: Stdlib_Option.getOr(message, "")
    }, undefined, undefined);
    onGoBack();
  }, []);
  let onSubmitFailure = React.useCallback(message => notifier.reset({
    TAG: "Error",
    _0: message
  }, undefined, undefined), []);
  let results = CatalogDuplication__Config.use(match[1], match$1[1], duplicationMode);
  if (typeof results !== "object") {
    if (results === "Error") {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    } else {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
    }
  }
  let match$3 = results._0;
  return JsxRuntime.jsx(CatalogDuplicationForm.Core.LegacyProvider.make, {
    initialValues: match$3.initialValues,
    schema: schema,
    children: JsxRuntime.jsx(CatalogDuplicationPage.make, {
      cku: cku,
      references: match$3.references,
      duplicationMode: duplicationMode,
      shopsData: match$3.shopsData
    }),
    id: cku,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
}

let make = React.memo(CatalogDuplicationContainer);

let Config;

let ProductsQuery;

let VariantsQuery;

export {
  Config,
  ProductsQuery,
  VariantsQuery,
  schema,
  make,
}
/* make Not a pure module */
